import { render, staticRenderFns } from "./IndicationsTable.vue?vue&type=template&id=dd475902&scoped=true"
import script from "./IndicationsTable.vue?vue&type=script&lang=js"
export * from "./IndicationsTable.vue?vue&type=script&lang=js"
import style0 from "./IndicationsTable.vue?vue&type=style&index=0&id=dd475902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd475902",
  null
  
)

export default component.exports